import { createContext, useContext } from "react";
import { Classification } from "./OsmPoiClassifications";

export interface OsmPoiContextType {
  expanded: { classes: number[] };
  toggleClass: (classification: Classification) => void;
  expandClass: (classification: Classification) => void;
  isSelfOrAncestorsSelected: (classification: Classification) => boolean;
  anyDecendentSelected: (classification: Classification) => boolean;
  sort: (a: Classification, b: Classification) => number;
}

const OsmPoiContext = createContext<OsmPoiContextType | undefined>(undefined);

const useOsmPoiContext = () => {
  // get the context
  const context = useContext(OsmPoiContext);

  // if `undefined`, throw an error
  if (context === undefined) {
    throw new Error("useOsmPoiContext was used outside of its Provider");
  }

  return context;
};

export { OsmPoiContext, useOsmPoiContext };
